import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendar2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCalendar2"><Path fillRule="evenodd" clipRule="evenodd" d="M8.5 2V4H15.5V2H17V4H21V21H3V4H7V2H8.5ZM4.5 10.5V19.5H19.5V10.5H4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendar2;
